import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SmsType } from "@/models/club";
import useStore from "@/store/regionMessage";
import CampaignPage, { CampaignActions } from "@/modules/marketing/CampaignPage";
import TemplatePicker, { useMessageParts } from "@/modules/marketing/TemplatePicker";
export default function SelectAreaTemplate() {
  const store = useStore();
  const [selected, setSelected] = useState(store.smsTemplate);
  const navigate = useNavigate();
  const parts = useMessageParts(selected?.text);
  const next = () => { if (!selected?.id) return; store.setTemplate({smsTemplate:selected}); navigate("/dashboard/areaMessage/selectInformation"); };
  return <CampaignPage flow="area" step={1} title="متنی انتخاب کنید که دیده شود" description="متن مناسب را انتخاب کنید و پیش‌نمایش آن را قبل از ادامه ببینید." previewText={selected?.text ?? ""} mobilePreview={false} actions={<CampaignActions back="/dashboard/areaMessage/selectArea" next="ادامه" onNext={next} disabled={!selected?.id} hint={selected ? `متن: ${selected.title}` : "یک متن برای پیامک انتخاب کنید"} meta={parts} />}>
    <TemplatePicker smsType={SmsType.Value2} value={selected} onChange={setSelected} />
  </CampaignPage>;
}
